import { defineStore } from 'pinia';
import { DemoRequestKind } from '@/types/composition-functions';

const COUNTRY_KEY = 'gradeverse.landing.country';

function readStoredCountry(): string | null {
  try {
    const value = localStorage.getItem(COUNTRY_KEY);
    return value && /^[A-Z]{2}$/.test(value) ? value : null;
  } catch {
    return null;
  }
}

/**
 * Client-only UI state for the public landing page: the country the visitor
 * picked (remembered on this device) and the shared demo-request dialog that
 * every "Request a Demo" / "Talk to Sales" button opens.
 */
export const useLandingStore = defineStore('landing-store', () => {
  const countryOverride = ref<string | null>(readStoredCountry());
  const demoDialogVisible = ref(false);
  const demoKind = ref<DemoRequestKind>(DemoRequestKind.Demo);

  function setCountry(code: string) {
    countryOverride.value = code.toUpperCase();
    try {
      localStorage.setItem(COUNTRY_KEY, countryOverride.value);
    } catch {
      // Storage blocked (private mode): the choice still holds for this visit.
    }
  }

  function openDemo(kind: DemoRequestKind = DemoRequestKind.Demo) {
    demoKind.value = kind;
    demoDialogVisible.value = true;
  }

  function closeDemo() {
    demoDialogVisible.value = false;
  }

  return { countryOverride, demoDialogVisible, demoKind, setCountry, openDemo, closeDemo };
});
